<script lang="ts">
    import {onDestroy} from 'svelte'
    import Alert from 'src/components/#common/alert/Alert.svelte'
    import {autoScrollTop} from 'src/components/cabinet/#common/helpers'
    import {api} from "src/services/api/reallis/index"

    export let title

    if (typeof window !== 'undefined') {
        onDestroy(autoScrollTop({
            onPushState: true,
            onReloadPage: true
        }))
    }
    let mobileMenuOpened = false

    function logOut() {
        api.ws.ws1.auth.logout()
    }
</script>

<div class="app">
    <div class="content">
        <div class="container-fluid">
            <Alert/>
            <slot name="content"/>
        </div>
    </div>
</div>

<style lang="postcss">
    .app {
        font-size: 1rem;
        line-height: 1.5;
        color: #6c757d;
        font-weight: 400;
        background: #1c1d21;
        font-family: 'Rubik', sans-serif;
        height: 100%;
        overflow: hidden;
        width: 100%;

        :global {
            @import 'src/styles/app.pcss';
        }
    }
</style>
